<template>
  <div class="page page2 multi">
    <van-form @submit="submitForm">
      <div class="tg-multi">
        <!-- <van-uploader> -->
        <ul class="clearfix">
          <li class="item" v-for="(item, index) in form.imgs" :key="index">
            <a
              href="javascript: void(0);"
              class="upload-pic-multi"
              @click="showSwiper(index)"
              ><img :src="item.url"
            /></a>
            <van-loading
              size="24px"
              vertical
              v-show="
                fileList[index] &&
                  fileList[index].status &&
                  fileList[index].status == 'uploading'
              "
              >上传中...</van-loading
            >
            <i
              class="van-icon van-icon-clear van-uploader__preview-delete"
              @click="deleteUpload(index)"
            ></i>
            <!-- <div class="progress-wrap" style="display: none;">
              <progress max="100" id="progressbar" value="0"></progress>
            </div> -->
          </li>
          <li class="add-item" @click="changePhotos">
            <div class="van-uploader__upload">
              <i
                class="van-icon van-icon-photograph van-uploader__upload-icon"
              ></i>
            </div>
          </li>
        </ul>
        <van-uploader
          style="display:none;"
          v-model="fileList"
          ref="uploadFile"
          :after-read="handleUpload"
          :before-read="beforeUpload"
          @delete="deleteUpload"
          :preview-image="false"
          multiple
          @click-preview="showSwiper"
          :max-count="maxCount"
          :preview-full-image="false"
        >
        </van-uploader>
      </div>
      <div class="tips" v-if="msg != ''">
        {{ msg }}
      </div>
      <div class="tips">
        *本赛事仅支持{{ gourp_limit.typestr }}格式且不大于{{
          gourp_limit.size
        }}M的图片
      </div>
      <div class="form">
        <div class="info-ipt">
          <van-field
            class="required"
            v-model="form.mname"
            name="作品名称"
            label="作品名称"
            maxlength="15"
            placeholder="请输入15字以内作品名称"
            :rules="[{ required: true, message: '作品名称不能为空' }]"
          />
          <van-field
            class="required"
            v-for="(item, index) in custom_fields"
            v-model="form.custom_fields[index]"
            :key="index"
            :name="item"
            :label="item"
            :placeholder="'请输入' + item"
            :rules="[{ required: true, message: item + '不能为空' }]"
          />
          <van-field
            v-model="form.shoot_address"
            name="作品拍摄地"
            label="作品拍摄地"
            v-if="gourp_limit.is_open_psd == 1"
            placeholder="请输入作品拍摄地"
          />
          <van-field
            class="required"
            v-model="form.shoot_address"
            name="作品拍摄地"
            label="作品拍摄地"
            v-if="gourp_limit.is_open_psd == 2"
            placeholder="请输入作品拍摄地"
            :rules="[{ required: true, message: '作品拍摄地不能为空' }]"
          />
          <van-field
            v-if="id!=10608"
            v-model="form.remark"
            rows="5"
            autosize
            label="作品描述"
            type="textarea"
            maxlength="500"
            placeholder="请输入作品描述"
            show-word-limit
          />
          <van-field
            v-if="id==10608"
            class="required"
            v-model="form.custom_fields[0]"
            rows="5"
            autosize
            label="文章阐述"
            type="textarea"
            maxlength="3000"
            placeholder="请输入文章阐述"
            :rules="[{ required: true, message: '文章阐述不能为空' }]"
            show-word-limit
          />
          <van-field
            v-if="id==10608"
            class="required"
            v-model="form.custom_fields[1]"
            rows="5"
            autosize
            label="照片说明"
            type="textarea"
            maxlength="3000"
            placeholder="请输入每幅图片说明"
            :rules="[{ required: true, message: '照片说明不能为空' }]"
            show-word-limit
          />
        </div>
        <div class="submit-item">
          <label @click="changeSync">
            <input class="check" type="checkbox" :checked="form.is_app_show" />
            <span class="text" @click.stop> 我同意将该图片同步到app发现中</span>
          </label>
        </div>
        <div class="agreement-tips">
          发布即表示您已同意我们的<a
            href="https://www.pai2345.com/wap/treaty/index/id/9"
            >原创条款</a
          >
        </div>
        <van-button
          class="btn-submit"
          round
          block
          type="warning"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>
    <div class="swiper-wrap" v-show="isShowSwiper">
      <div class="swiper-container detail">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in form.imgs"
            :key="index"
          >
            <img :src="item.url" />
            <!-- <img
              :src="item.file ? item.file.url + '/' + item.file.key : item.url"
            /> -->
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <a
          class="del-btn"
          href="javascript:void(0)"
          @click="deleteUploadSwiper()"
        ></a>
        <a
          class="close-btn"
          href="javascript:void(0)"
          @click="isShowSwiper = false"
        ></a>
      </div>
    </div>
    <ChooseFile
      :chooseForm1="chooseForm1"
      :max="maxCount"
      :chooseType="chooseType"
      :uploadImages="form.imgs"
      @changeChooseForm1="changeChooseForm1"
      @changeChooseForm2="changeChooseForm2"
      @chooseFromSys="chooseFromSys"
      @chooseComplete="chooseComplete"
    />
    <!-- :limit="maxCount - form.imgs.length" -->
  </div>
</template>

<script>
import Swiper from "swiper/js/swiper.js";
import ChooseFile from "@/components/ChooseFile";
export default {
  components: {
    ChooseFile,
  },
  data() {
    return {
      isShowSwiper: false,
      uploadBg: require("@/static/res/images/img-bg.png"),
      dialogImageUrl: "",
      dialogVisible: false,
      id: this.$route.params.id,
      define: [],
      custom_fields: [],
      group: this.$route.query.group,
      // form
      form: {
        work_id: this.$route.query.work_id,
        match_id: this.$route.params.id,
        mname: "",
        remark: "",
        imgs: [],
        group: this.$route.query.group,
        shoot_address: "",
        custom_fields: [],
        // 是否同意条款
        is_app_show: 0,
        is_finding: 0,
        works_type: 2,
      },
      // 限制图片数量
      uploadImgLen: 0,
      maxCount: 1,
      accept: "image/*",
      fileList: [
        { file: "" },
        // {
        //   percent: 0,
        //   url: "",
        //   // status: 'uploading',
        //   // message: '上传中...'
        // }
      ],
      isUploaded: true,
      gourp_limit: {
        typestr: "",
        imgtype: [],
        size: "",
        end: 2,
        start: 1,
        is_open_psd: 0,
      },
      msg: "",
      has_submit: true,
      loading: false,
      swiper: "",
      realIndex: 0,
      chooseForm1: false,
      chooseForm2: false,
      // 已选择的图片
      uploadImages: [],
      chooseType: "multi",
    };
  },
  computed: {
    // newFileList() {},
  },
  methods: {
    // changePhotos() {
    //   this.$refs.multi.chooseFile();
    // },
    changePhotos() {
      this.chooseForm1 = true;
    },
    changeChooseForm1(val) {
      this.chooseForm1 = val;
    },
    changeChooseForm2(val) {
      this.chooseForm2 = val;
    },
    chooseFromSys() {
      this.$refs.uploadFile.chooseFile();
    },
    chooseComplete(val) {
      console.log("before update:", val, this.form.imgs);

      this.form.imgs = val;
      this.fileList = val;
      // this.selectedList = val;
      // if (!!val && val.length > 0 && this.form.imgs != undefined) {
      //   this.form.imgs = val;
      //   this.fileList = val;
      //   this.form.mname = this.form.mname || this.form.imgs[0].title;
      //   this.form.remark = this.form.remark || this.form.imgs[0].content;
      // }
    },
    checkValFilter(item) {
      // 未打开图库删减图库内容时，校正checkVal值
      // session取值
      let checkVal = JSON.parse(sessionStorage.getItem("checkVal")) || [];
      // 过滤
      checkVal = checkVal.filter((val) => {
        return val != item.id;
      });
      // 存储
      if (checkVal.length <= 0) {
        sessionStorage.removeItem("checkVal");
      } else {
        sessionStorage.setItem("checkVal", JSON.stringify(checkVal));
      }
    },
    initSwiper() {
      var that = this;
      // var mySwiper =
      this.swiper = new Swiper(".swiper-container", {
        initialSlide: that.realIndex,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        // loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          // slideChangeTransitionEnd
          slideChangeTransitionEnd: function() {
            that.realIndex = this.realIndex;
          },
        },
      });
    },
    showSwiper(index) {
      this.isShowSwiper = true;
      this.realIndex = index;
      this.initSwiper();
    },
    initFileList(end) {
      this.fileList = [];
      for (var j = 0; j < end; j++) {
        this.fileList.push({
          percent: 0,
          url: "",
        });
      }
    },
    addFileList(arr) {
      for (var i = 0; i < arr.length; i++) {
        this.fileList[i].file.key = arr[i].image;
        this.fileList[i].file.url = arr[i].url.split("/uploads")[0];
      }
    },
    changeSync() {
      this.form.is_app_show = !this.form.is_app_show;
    },
    // 校验图片是否符合限制
    valid(file) {
      let isJPG = this.tools.hasImgType(this.gourp_limit.imgtype, file.type);
      let isLt2M = file.size / 1024 / 1024 < this.gourp_limit.size;
      if (!isJPG) {
        this.$toast.fail({
          message: "上传图片只能是 " + this.gourp_limit.typestr + " 格式!",
          duration: 3500,
          className: "long-toast",
        });
        return false;
      }
      if (!isLt2M) {
        this.$toast.fail(
          "上传图片大小不能超过 " + this.gourp_limit.size + "MB!"
        );
        return false;
      }
      return isJPG && isLt2M;
    },
    // 图片上传前处理
    beforeUpload(file) {
      //类型判断need imgtype: [],
      if (typeof file == "object" && file.length > 0) {
        let result = file.filter((item) => {
          return this.valid(item);
        });
        // 数组过滤后长度不等于原先的，说明有文件不符合预期，不上传
        return result.length == file.length;
      } else {
        return this.valid(file);
      }
    },
    // 图片上传事件抽象
    upload(file) {
      // var file = option.file;
      var _file = file.file;
      file.status = "uploading";
      file.message = "上传中...";
      // 传图前，loading状态
      let length = this.form.imgs.length;

      this.form.imgs[length] = { isLoading: true, url: file.content };

      // 传图失败，减少imgs长度
      this.tools
        .uploadaly(_file)
        .then((res) => {
          if (res) {
            // this.form.imgs.push({ url: res });
            // this.form.imgs[this.form.imgs.length - 1].url = res;
            this.form.imgs[length].isLoading = false;
            this.form.imgs[length].url = res;
            file.status = "";
            file.message = "";
          }
        })
        .catch((err) => {
          console.log(err);
          this.form.imgs.pop();
          file.status = "fail";
          file.message = "上传失败";
        });
    },
    // 图片上传实际函数
    handleUpload(files) {
      if (typeof files == "object" && files.length > 0) {
        for (let file of files) {
          this.upload(file);
        }
      } else {
        this.upload(files);
      }
    },
    deleteUpload(index) {
      this.checkValFilter(this.form.imgs[index]);
      this.form.imgs.splice(index, 1);
    },

    deleteUploadSwiper() {
      this.$dialog
        .confirm({
          title: "",
          message: "要删除这张照片吗？",
          confirmButtonText: "删除",
          cancelButtonText: "取消",
        })
        .then(() => {
          // on confirm
          this.checkValFilter(this.form.imgs[this.realIndex]);
          this.fileList.splice(this.realIndex, 1);
          this.form.imgs.splice(this.realIndex, 1);
          if (this.fileList.length == 0) {
            this.isShowSwiper = false;
          }
        })
        .catch(() => {
          // on cancel
          return false;
        });

    },
    // submitForm(value) {
    submitForm() {
      // let that = this;
      if (!this.$store.state.isLogin) {
        /* eslint-disable */
        // 调用passport
        passportLogin.login();
        /* eslint-enable */
        return false;
      }
      if (this.has_submit) {
        this.has_submit = false;
        var fase = true;
        if (this.form.imgs.length == 0) {
          this.$toast.fail("请先上传图片");
          fase = false;
        }
        if (this.gourp_limit.start == 0) {
          this.gourp_limit.start = 2;
        }
        if (this.form.imgs.length < this.gourp_limit.start) {
          this.$toast.fail({
            message:
              "本次投稿需要上传至少 " +
              this.gourp_limit.start +
              " 张图片\n请调整后重试！",
            duration: 3500,
            className: "long-toast",
          });
          fase = false;
        }
        if (this.gourp_limit.is_open_psd == 2) {
          if (this.form.shoot_address == "") {
            this.$toast.fail("图片拍摄地必须填写");
            fase = false;
          }
        }
        if (fase) {
          this.form.is_finding = this.form.is_app_show;
          this.axios
            .post("/match/join_multi", {
              ...this.form,
            })
            .then(
              (res) => {
                if (res.data.code == 200) {
                  if (this.form.work_id > 0) {
                    sessionStorage.removeItem("checkVal");
                    // 作品的再投一稿
                    this.$router.push({
                      query: {
                        group: this.group,
                      },
                    });
                  }
                  this.$dialog
                    .confirm({
                      title: "",
                      message: "投稿成功!",
                      confirmButtonText: "再投一稿",
                      cancelButtonText: "返回赛事页",
                    })
                    .then(() => {
                      // on confirm
                      window.location.reload();
                      sessionStorage.removeItem("checkVal");
                    })
                    .catch((action) => {
                      // on cancel
                      console.log(action);
                      sessionStorage.removeItem("checkVal");
                      this.$router.push({
                        name: "intro",
                      });
                    });
                } else {
                  // this.$toast.fail(res.data.msg);
                  this.$toast.fail({
                    message: res.data.msg,
                    duration: 3500,
                    className: "long-toast",
                  });
                }
                this.has_submit = true;
              },
              (err) => {
                this.has_submit = true;
                console.log(err);
              }
            );
        } else {
          this.has_submit = true;
        }
      }
    },
  },
  created() {
    this.fileList = [];
    this.form.custom_fields[0] = '';
    this.form.custom_fields[1] = '';
  },
  mounted() {
    // 每次加载都清空图库选择状态
    sessionStorage.removeItem("checkVal");
    // 获取比赛详情
    this.tools
      .getMatchDetail({ id: this.id, group: this.group })
      .then((res) => {
        this.custom_fields = res.custom_fields;
        this.msg = res.match_limit.match_introduce;
        this.form.is_app_show = res.match_limit.is_app_show;
        var params = res.gourp_limit;
        if (params) {
          this.gourp_limit = Object.assign(this.gourp_limit, params);
          this.gourp_limit.size = params.file_limit;
          this.gourp_limit.imgtype = params.file_limit_type;
          this.maxCount = this.gourp_limit.end == 0 ? 15 : this.gourp_limit.end;
          // this.initFileList(this.gourp_limit.end);
          this.gourp_limit.typestr = this.gourp_limit.imgtype.toString();
          if (this.$route.query.work_id) {
            this.tools
              .getWorksDetail({ work_id: this.$route.query.work_id })
              .then((res) => {
                // this.form = res.form;
                Object.assign(this.form, res.form);
                // this.addFileList(res.imgs);
                this.form.imgs = res.imgs;
                this.fileList = res.imgs;
              });
          }
        }
      });
  },
};
</script>

<style lang="scss">
@import "../../../node_modules/swiper/css/swiper.min.css";
.multi {
  .tg-multi {
    padding: 30px 0 0 30px;
    li {
      margin: 0 30px 30px 0;
      .van-loading {
        background: rgba(0, 0, 0, 0.5);
        height: 100%;
        border-radius: 8px; /* no */
        align-items: center;
        justify-content: center;
        color: #fff;
        .van-loading__text {
          color: #fff;
        }
      }
      img {
        border-radius: 8px; /* no */
      }
    }
  }
  textarea {
    word-break: break-all;
    word-wrap: break-word;
  }
  .van-uploader__upload,
  .van-uploader__preview {
    margin: 0 30px 30px 0;
    width: 210px;
    height: 210px;
  }

  .van-uploader__preview-image {
    width: 210px;
    height: 210px;
  }
  .van-field__label {
    width: 180px;
  }
  .required {
    .van-field__label {
      span::after {
        content: "*";
        color: #dd855c;
        position: absolute;
        left: 18px;
        top: 30px;
      }
    }
  }
  .van-uploader__input-wrapper {
    width: 100vw;
  }
  .van-button {
    line-height: 1;
  }
  .van-uploader__preview-delete {
    font-size: 24px; /* no */
  }
  .swiper-wrap {
    position: absolute;
    top: 0;
    height: 100vh;
    width: 100%;
    background: rgba(0, 0, 0, 0.8);
  }
}
.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #ef7f48;
}
.long-toast {
  width: 80%;
  max-width: 80%;
}
</style>
